import React from "react";

const DashboardHome = () => {
  return (
    <div className="dashboard-height">
      <h2>Welcome to Dashboard. </h2>
    </div>
  );
};

export default DashboardHome;
